"use client";

import { createContext, useContext } from "react";
import type {
  TitleHeadingLayout,
  TitleHeadingMarkerColor,
  TitleHeadingSize,
  TitleHeadingTitleColor,
} from "./title-heading";

export interface TitleHeadingContextValue {
  layout: TitleHeadingLayout;
  size: TitleHeadingSize;
  titleColor: TitleHeadingTitleColor;
  markerColor: TitleHeadingMarkerColor;
}

export const TitleHeadingContext = createContext<TitleHeadingContextValue | null>(null);

export const useTitleHeading = (): TitleHeadingContextValue => {
  const ctx = useContext(TitleHeadingContext);
  if (!ctx) throw new Error("TitleHeading parts must be used within <TitleHeading>.");
  return ctx;
};
